import React, { useState, useEffect } from 'react';
import { capatazService } from '../services/api';
import { useAuth } from '../contexts/AuthContext';
import '../styles/Capataces.css';

const Capataces = () => {
  const { usuario } = useAuth();
  const [capataces, setCapataces] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalBuscar, setModalBuscar] = useState(false);
  const [codigoBusqueda, setCodigoBusqueda] = useState('');
  const [capatazEncontrado, setCapatazEncontrado] = useState(null);

  useEffect(() => {
    cargarCapataces();
  }, []);

  const cargarCapataces = async () => {
    try {
      const response = await capatazService.getLista();
      setCapataces(response.data);
    } catch (error) {
      console.error('Error al cargar capataces:', error);
    } finally {
      setLoading(false);
    }
  };

  const buscarCapataz = async () => {
    if (!codigoBusqueda) {
      alert('Ingresa un código de capataz');
      return;
    }

    try {
      const response = await capatazService.buscar(codigoBusqueda);
      setCapatazEncontrado(response.data);
    } catch (error) {
      console.error('Error al buscar capataz:', error);
      alert(error.response?.data?.error || 'Capataz no encontrado');
      setCapatazEncontrado(null);
    }
  };

  const enviarInvitacion = async (capataz_id) => {
    try {
      await capatazService.invitar(capataz_id);
      alert('Invitación enviada exitosamente');
      setModalBuscar(false);
      setCodigoBusqueda('');
      setCapatazEncontrado(null);
      cargarCapataces();
    } catch (error) {
      console.error('Error al enviar invitación:', error);
      alert(error.response?.data?.error || 'Error al enviar invitación');
    }
  };

  const reenviarInvitacion = async (capataz_id) => {
    if (!window.confirm('¿Reenviar la invitación a este capataz?')) return;

    try {
      await capatazService.reenviarInvitacion(capataz_id);
      alert('Invitación reenviada exitosamente');
    } catch (error) {
      console.error('Error al reenviar invitación:', error);
      alert(error.response?.data?.error || 'Error al reenviar invitación');
    }
  };

  const eliminarCapataz = async (capataz_id) => {
    if (!window.confirm('¿Estás seguro de deshabilitar este capataz?')) return;

    try {
      await capatazService.eliminar(capataz_id);
      alert('Capataz deshabilitado');
      cargarCapataces();
    } catch (error) {
      console.error('Error al eliminar capataz:', error);
      alert(error.response?.data?.error || 'Error al eliminar capataz');
    }
  };

  if (loading) {
    return <div className="loading">Cargando capataces...</div>;
  }

  return (
    <div className="capataces-container">
      <div className="page-header">
        <h1>Capataces</h1>
        <button className="btn btn-primary" onClick={() => setModalBuscar(true)}>
          + Buscar Capataz
        </button>
      </div>

      {/* Mostrar QR del usuario si es capataz */}
      {usuario?.tipo === 'capataz' && usuario.codigo_unico && (
        <div className="mi-qr-card">
          <h2>Mi Código QR</h2>
          <p className="codigo-texto">Código: <strong>{usuario.codigo_unico}</strong></p>
          <p className="instrucciones">
            Comparte este código con tu contratista para que pueda agregarte a su equipo.
          </p>
          {usuario.qr_code_url && (
            <div className="qr-display">
              <img src={usuario.qr_code_url} alt="Mi código QR" />
            </div>
          )}
        </div>
      )}

      {capataces.length === 0 ? (
        <div className="empty-state">
          <p>No hay capataces asociados</p>
          <button className="btn btn-primary" onClick={() => setModalBuscar(true)}>
            Buscar primer capataz
          </button>
        </div>
      ) : (
        <div className="capataces-grid">
          {capataces.map(capataz => (
            <div key={capataz.id} className="capataz-card">
              <div className="capataz-header">
                <div>
                  <h3>{capataz.nombre}</h3>
                  {capataz.especialidad && (
                    <p className="especialidad">{capataz.especialidad}</p>
                  )}
                </div>
                <span className={`estado-badge ${capataz.estado_asociacion}`}>
                  {capataz.estado_asociacion}
                </span>
              </div>

              <div className="capataz-info">
                {capataz.email && (
                  <p><strong>Email:</strong> {capataz.email}</p>
                )}
                {capataz.telefono && (
                  <p><strong>Teléfono:</strong> {capataz.telefono}</p>
                )}
                <p><strong>Código:</strong> {capataz.codigo_unico}</p>
              </div>

              <div className="capataz-actions">
                {capataz.estado_asociacion === 'pendiente' && (
                  <button
                    className="btn btn-warning"
                    onClick={() => reenviarInvitacion(capataz.id)}
                    title="Reenviar correo de invitación"
                  >
                    📧 Reenviar Invitación
                  </button>
                )}
                {capataz.estado_asociacion === 'aceptado' && (
                  <button
                    className="btn btn-danger"
                    onClick={() => eliminarCapataz(capataz.id)}
                  >
                    Deshabilitar
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Modal Buscar Capataz */}
      {modalBuscar && (
        <div className="modal-overlay" onClick={() => setModalBuscar(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <h2>Buscar Capataz</h2>
            <p>Ingresa el código del capataz o escanea su código QR</p>

            <div className="buscar-capataz">
              <div className="form-group">
                <label>Código del Capataz</label>
                <div className="input-con-boton">
                  <input
                    type="text"
                    value={codigoBusqueda}
                    onChange={(e) => setCodigoBusqueda(e.target.value)}
                    placeholder="Ingresa el código de 8 dígitos"
                    maxLength="8"
                  />
                  <button
                    className="btn btn-primary"
                    onClick={buscarCapataz}
                  >
                    Buscar
                  </button>
                </div>
              </div>

              {capatazEncontrado && (
                <div className="capataz-encontrado">
                  <h3>Capataz Encontrado</h3>
                  <div className="info-encontrado">
                    <p><strong>Nombre:</strong> {capatazEncontrado.nombre}</p>
                    <p><strong>Email:</strong> {capatazEncontrado.email}</p>
                    {capatazEncontrado.especialidad && (
                      <p><strong>Especialidad:</strong> {capatazEncontrado.especialidad}</p>
                    )}
                    {capatazEncontrado.telefono && (
                      <p><strong>Teléfono:</strong> {capatazEncontrado.telefono}</p>
                    )}

                    {capatazEncontrado.contratista_id ? (
                      <div className="alert alert-warning">
                        Este capataz ya está asociado a otro contratista
                      </div>
                    ) : (
                      <button
                        className="btn btn-success"
                        onClick={() => enviarInvitacion(capatazEncontrado.id)}
                      >
                        Enviar Invitación
                      </button>
                    )}
                  </div>
                </div>
              )}
            </div>

            <div className="modal-actions">
              <button
                className="btn btn-secondary"
                onClick={() => {
                  setModalBuscar(false);
                  setCodigoBusqueda('');
                  setCapatazEncontrado(null);
                }}
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Capataces;
